import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Col, FlexboxGrid, Icon, Input, InputNumber, Message, Nav, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import EditFormListWidget from '../dynamicForm/EditFormListWidget'
import ViewFormListWidget from '../dynamicForm/ViewFormListWidget'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import ActivitieTimeWidget from './ActivitieTimeWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep, forEach } from 'lodash-es'
import ActivitieBudgetWidget from './ActivitieBudgetWidget'
import EditFormList2Widget from '../dynamicForm/EditFormList2Widget'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import HTMLWidget from '../../HTMLWidget'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'
import WhisperMoreContent from '../../WhisperMoreContent'
import ActivitieTimeViewWidget from './ActivitieTimeViewWidget'
import ActivitieFormWidget from './ActivitieFormWidget'
import {
  deleteFormActivity,
  getFormActivities,
  saveFormActivity,
  saveFormActivityAdditionalSupport,
} from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import CustomAlertMessage from '../../CustomAlertMessage'
import NumberFormat from 'react-number-format'

export default function ActivitieWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [activities, setActivities] = useState([])

  const [delActivityId, setDelActivityId] = useState()

  const [activityIndex, setActivityIndex] = useState(1)
  const [moreContent, setMoreContent] = useState(true)

  const [viewMode, setViewMode] = useState(true)
  const [haveChange, setHaveChange] = useState()
  const [isRefash, setIsRefash] = useState(false)

  const [budgetMap, setBudgetMap] = useState(new Map())
  const [totalBudget, setTotalBudget] = useState(0)

  const [additionalSupport, setAdditionalSupport] = useState(0)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    setActivities(props.schema.activities || [])
    calculateTotalBudget(props.schema.activities || [])

    var otherSupport = props.schema?.activitiNote?.additionalSupport || 0

    otherSupport += props.schema?.additionalSupport?.additionalSupport?.value || 0

    setAdditionalSupport(otherSupport)
    //mapActiveKeys(props.schema.activities || [])
  }, [props.schema])

  useEffect(() => {
    if (haveChange && !isEdit) {
      handleReload()
    }
  }, [isEdit])

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
      scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
    }, 50)
  }

  const handleReload = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await getFormActivities(subProjectId)
      // console.log(response)

      if (response?.forms?.activity) {
        setFormSchema(response?.forms?.activity)
        setActivities(response?.forms?.activity?.activities || [])

        calculateTotalBudget(response?.forms?.activity?.activities || [])

        setHaveChange(false)
        onRefash()
      }
    } catch (e) {}

    doneLoading()
    setIsLoading(false)
  }

  const handleDelete = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await deleteFormActivity(subProjectId, id)
      if (response) {
        // setFormSchema(response)
        setActivities(response.activities || [])
        calculateTotalBudget(response.activities || [])

        setAlertMessage('success', DELETE_SUCCESS_MSG)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSaveAdditionalSupport = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let req = {
        id: formSchema.additionalSupport.id,
        additionalSupport: additionalSupport,
        note: '',
      }

      let response = await saveFormActivityAdditionalSupport(subProjectId, req)

      if (response) {
        setAlertMessage('info', SAVE_SUCCESS_MSG)
        // scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('error', e)

      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    doneLoading()
    setIsLoading(false)
  }

  const calculateTotalBudget = (datas) => {
    let totalBudget = 0
    let objMap = new Map()

    datas
      ?.filter((e) => e.id?.length > 0)
      ?.forEach((element) => {
        let total = element.activityBudgetDatas?.reduce(
          (sum, item) => sum + item.quantity * item.price,
          0
        )

        objMap.set(element.id, total)

        totalBudget += total
      })

    setBudgetMap(objMap)
    setTotalBudget(totalBudget)
  }

  const updateBudgetTotal = (id, budget) => {
    let map = cloneDeep(budgetMap)

    map.set(id, budget)

    let total = Array.from(map?.values())?.reduce((sum, val) => sum + val, 0)

    setBudgetMap(map)
    setTotalBudget(total)
  }

  const handleAdd = () => {
    let atts = cloneDeep(activities || [])

    let obj = {
      id: 'NEW_' + (activityIndex + 1),
      enableEdit: true,
      activityName: '',
      activityDetail: '',
      outcomes: [],
      newOutcomes: [],
      activityTime: [],
      activityBudgetDatas: [],
      activityBudgetNote: null,
    }

    atts.push(obj)

    setActivities(atts)
    setActivityIndex(activityIndex + 1)
  }

  const handleDel = (id, index) => {
    if (id.startsWith('NEW_')) {
      let atts = cloneDeep(activities || [])

      atts.splice(index, 1)

      setActivities(atts)
    } else {
      setDelActivityId(id)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}
      <HTMLWidget style={{ marginBottom: 20 }} data={formSchema.detail} />

      {!isRefash && (
        <>
          {isEdit && showCommandButton ? (
            <>
              {formSchema.description && (
                <div style={{ marginBottom: 15 }}>
                  <CustomAlertMessage contents={formSchema.description} />
                </div>
              )}

              {activities?.map((e, index) => {
                return (
                  <ActivitieFormWidget
                    schema={formSchema}
                    activity={e}
                    activityIndex={index}
                    onDelete={handleDel}
                    setHaveChange={setHaveChange}
                    updateBudgetTotal={updateBudgetTotal}
                  />
                )
              })}

              <SaveButton
                style={{ marginTop: 0, marginBottom: 20 }}
                icon="plus"
                children="เพิ่มกิจกรรม"
                onClick={handleAdd}
              />

              {formSchema.additionalSupport && (
                <>
                  <hr />
                  <Row>
                    <Col lg={4} md={8} sm={12} xs={24}>
                      <label>{formSchema.additionalSupport.additionalSupport.label}</label>
                      <Input
                        name={formSchema.additionalSupport.additionalSupport.name}
                        defaultValue={additionalSupport}
                        value={additionalSupport}
                        thousandSeparator={true}
                        onChange={(value) => {
                          let val = value?.replace(' ', '')

                          if (isNaN(val)) {
                            return
                          }

                          const regex = /^\d*\.?\d{0,2}$/

                          if (regex.test(val)) {
                            setAdditionalSupport(val)
                          }
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 15 }}>
                    <Col>
                      <SaveButton children="บันทึก" onClick={handleSaveAdditionalSupport} />
                    </Col>
                  </Row>
                </>
              )}
            </>
          ) : (
            <>
              {activities?.map((e, index) => {
                return (
                  <Panel
                    //header={`กิจกรรมที่ ${index + 1}`}
                    header={e.activityName || 'กิจกรรม'}
                    collapsible
                    defaultExpanded
                    bordered
                    style={{ marginBottom: 20 }}
                  >
                    <>
                      <Row style={{ marginBottom: 20 }}>
                        <Col style={{ marginBottom: 10 }}>
                          <strong>{formSchema.activityForm.activityName.label}</strong>{' '}
                        </Col>
                        <Col style={{ marginLeft: 20 }}>{e.activityName}</Col>
                      </Row>
                      <Row style={{ marginBottom: 20 }}>
                        <Col style={{ marginBottom: 10 }}>
                          <strong>{formSchema.activityForm.activityDetail.label}</strong>
                        </Col>
                        <Col style={{ marginLeft: 20 }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: e.activityDetail,
                            }}
                          />
                        </Col>
                      </Row>
                    </>

                    <Panel
                      // style={{ marginTop: -22 }}
                      header={'ผลลัพธ์/ผลผลิต'}
                      collapsible
                      defaultExpanded
                      bordered
                    >
                      <div style={{ marginTop: -10 }}>
                        <ViewFormListWidget
                          style={{ marginTop: -20 }}
                          prefix={'- '}
                          objects={[...(e.outcomes || []), ...(e.newOutcomes || [])]}
                        />
                      </div>
                    </Panel>

                    <ActivitieTimeViewWidget
                      // style={{ marginTop: -22 }}
                      bordered
                      schema={formSchema.activityTimeForm}
                      header={'ช่วงเวลาที่จัดกิจกรรม'}
                      items={e.activityTimeForm}
                      newItems={e.activityTime}
                    />

                    <ActivitieBudgetWidget
                      // style={{ marginTop: -22 }}
                      bordered
                      isView
                      header={'งบประมาณ'}
                      dataList={e.activityBudgetDatas || []}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      budgetNote={e.activityBudgetNote}
                    />
                  </Panel>
                )
              })}
            </>
          )}

          <hr />
          <FlexboxGrid>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ textAlign: 'right' }}
            >
              รวมงบประมาณที่ขอสนับสนุนจาก สสส. :
            </FlexboxGrid.Item>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ maxWidth: 170, textAlign: 'right' }}
            >
              <b>{numberThousandSeparator(totalBudget)}</b> บาท.
            </FlexboxGrid.Item>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ textAlign: 'right' }}
            >
              ส่วนที่ สสส. สนับสนุนเพิ่มเติม :
            </FlexboxGrid.Item>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ maxWidth: 170, textAlign: 'right' }}
            >
              <b>{numberThousandSeparator(Number(additionalSupport) || 0)}</b> บาท.
            </FlexboxGrid.Item>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ textAlign: 'right' }}
            >
              รวมงบประมาณทั้งโครงการ :
            </FlexboxGrid.Item>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ maxWidth: 170, textAlign: 'right' }}
            >
              <b>{numberThousandSeparator(totalBudget + (Number(additionalSupport) || 0))}</b> บาท.
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </>
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />

          {isEdit ? (
            <div>
              <ViewButton
                icon="backward"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข ' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}
        </div>
      )}

      {(formSchema.activitiNote?.requestMaximunDetail ||
        formSchema.activitiNote?.additionalSupportDetail ||
        formSchema.note) && (
        <div style={{ textAlign: 'center' }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}

      {(formSchema.activitiNote?.requestMaximunDetail ||
        formSchema.activitiNote?.additionalSupportDetail) &&
        moreContent && (
          <div>
            <Message
              showIcon
              type="info"
              description={
                <>
                  {/* <hr /> */}
                  <div style={{ width: '100%', textAlign: 'center' }}>
                    {/* <p>
                    <strong>
                      {formSchema.activitiNote.requestMaximunLabel}{' '}
                      {numberThousandSeparator(formSchema.activitiNote.requestMaximun)} บาท{' '}
                    </strong>
                  </p> */}
                    <HTMLWidget
                      style={{ marginTop: 10 }}
                      data={formSchema.activitiNote.requestMaximunDetail}
                    />
                  </div>
                  <hr />
                  <HTMLWidget
                    style={{ marginLeft: 20, marginTop: -10 }}
                    data={formSchema.activitiNote.additionalSupportDetail}
                  />
                  {/*<hr />
                 <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bolder' }}>
                  {formSchema.activitiNote.limitBuugetText}{' '}
                  {numberThousandSeparator(
                    formSchema.activitiNote.requestMaximun +
                      formSchema.activitiNote.additionalSupport
                  )}{' '}
                  บาท
                </div> */}
                </>
              }
            />
          </div>
        )}

      {formSchema.note && moreContent && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      <ConfirmWidget
        title={`ยืนยัน`}
        show={delActivityId}
        detail={`ยืนยันการลบกิจกรรม `}
        onCancle={() => setDelActivityId('')}
        onConfirm={() => {
          handleDelete(delActivityId)
          setDelActivityId('')
        }}
      />
    </Panel>
  )
}
